import "./firebase/firebase";
import MainNav from "./components/MainNav";
function App() {
    return (
        <>
            <MainNav />
        </>
    );
}

export default App;
